import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ theme }) =>
    theme?.name === 'dark' ? 'rgba(0, 0, 0, 0.7)' : 'rgba(0, 0, 0, 0.5)'};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.2s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const ModalContainer = styled.div`
  background: ${({ theme }) =>
    theme?.name === 'dark' ? '#1F2937' : '#ffffff'};
  border-radius: 12px;
  width: 90%;
  max-width: 480px;
  max-height: 90vh;
  box-shadow: ${({ theme }) =>
    theme?.name === 'dark'
      ? '0 20px 25px -5px rgba(0, 0, 0, 0.5), 0 10px 10px -5px rgba(0, 0, 0, 0.3)'
      : '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'};
  animation: slideIn 0.3s ease-out;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  @keyframes slideIn {
    from {
      transform: translateY(-20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 0 24px;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: ${({ theme }) => (theme?.name === 'dark' ? '#F3F4F6' : '#0F172A')};
`;

export const CloseButton = styled.button`
  background: ${({ theme }) =>
    theme?.name === 'dark' ? '#374151' : '#f3f4f6'};
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  cursor: pointer;
  color: ${({ theme }) => (theme?.name === 'dark' ? '#9CA3AF' : '#6b7280')};
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover:not(:disabled) {
    background: ${({ theme }) =>
      theme?.name === 'dark' ? '#4B5563' : '#e5e7eb'};
    color: ${({ theme }) => (theme?.name === 'dark' ? '#F3F4F6' : '#374151')};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ModalBody = styled.div`
  padding: 24px;
  overflow-y: auto;
  flex: 1;
`;

export const ModalDescription = styled.p`
  margin: 0 0 24px 0;
  font-size: 14px;
  color: ${({ theme }) => (theme?.name === 'dark' ? '#9CA3AF' : '#6b7280')};
  line-height: 1.5;
`;

// Step indicator
export const StepIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 24px;
`;

export const Step = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StepNumber = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.2s ease;

  ${({ active, completed, theme }) =>
    completed
      ? `
    background: #22c55e;
    color: #ffffff;
  `
      : active
      ? `
    background: linear-gradient(135deg, #fa4616, #ff6b3b);
    color: #ffffff;
  `
      : `
    background: ${theme?.name === 'dark' ? 'rgba(255,255,255,0.1)' : '#e2e8f0'};
    color: ${theme?.name === 'dark' ? '#64748b' : '#94a3b8'};
  `}
`;

export const StepLabel = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${({ active, theme }) =>
    active
      ? theme?.name === 'dark'
        ? '#ffffff'
        : '#0F172A'
      : theme?.name === 'dark'
      ? '#64748b'
      : '#94a3b8'};
`;

export const StepDivider = styled.div`
  width: 40px;
  height: 2px;
  background: ${({ theme }) =>
    theme?.name === 'dark' ? 'rgba(255,255,255,0.1)' : '#e2e8f0'};
`;

// Form elements
export const FormGroup = styled.div`
  margin-bottom: 16px;
`;

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

// Search results
export const SearchResultsList = styled.div`
  border: 1px solid
    ${({ theme }) => (theme?.name === 'dark' ? '#374151' : '#e2e8f0')};
  border-radius: 8px;
  margin-top: 12px;
  max-height: 200px;
  overflow-y: auto;
`;

export const SearchResultItem = styled.div`
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid
    ${({ theme }) => (theme?.name === 'dark' ? '#374151' : '#e2e8f0')};
  transition: background 0.2s ease;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: ${({ theme }) =>
      theme?.name === 'dark'
        ? 'rgba(250, 70, 22, 0.1)'
        : 'rgba(250, 70, 22, 0.05)'};
  }
`;

export const SearchResultName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => (theme?.name === 'dark' ? '#F3F4F6' : '#0F172A')};
  margin-bottom: 4px;
`;

export const SearchResultPhone = styled.div`
  font-size: 13px;
  color: ${({ theme }) => (theme?.name === 'dark' ? '#9CA3AF' : '#6b7280')};
`;

export const NoResultsMessage = styled.div`
  padding: 20px 16px;
  text-align: center;
  color: ${({ theme }) => (theme?.name === 'dark' ? '#9CA3AF' : '#6b7280')};
  font-size: 14px;
  line-height: 1.6;
`;

// Selected user card
export const SelectedUserCard = styled.div`
  padding: 16px;
  background: ${({ theme }) =>
    theme?.name === 'dark'
      ? 'rgba(250, 70, 22, 0.1)'
      : 'rgba(250, 70, 22, 0.05)'};
  border: 1px solid
    ${({ theme }) =>
      theme?.name === 'dark'
        ? 'rgba(250, 70, 22, 0.3)'
        : 'rgba(250, 70, 22, 0.2)'};
  border-radius: 8px;
  margin-bottom: 16px;
`;

export const SelectedUserName = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => (theme?.name === 'dark' ? '#F3F4F6' : '#0F172A')};
  margin-bottom: 4px;
`;

export const SelectedUserDetail = styled.div`
  font-size: 14px;
  color: ${({ theme }) => (theme?.name === 'dark' ? '#9CA3AF' : '#6b7280')};
`;

// Buttons
export const FormButton = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  ${({ variant, theme }) =>
    variant === 'primary'
      ? `
    background: linear-gradient(135deg, #fa4616, #ff6b3b);
    color: #ffffff;
    border: none;

    &:hover:not(:disabled) {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(250, 70, 22, 0.3);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  `
      : `
    background: transparent;
    color: ${theme?.name === 'dark' ? '#9CA3AF' : '#64748b'};
    border: 1px solid ${
      theme?.name === 'dark' ? 'rgba(255, 255, 255, 0.2)' : '#e2e8f0'
    };

    &:hover {
      background: ${
        theme?.name === 'dark'
          ? 'rgba(255, 255, 255, 0.05)'
          : 'rgba(0, 0, 0, 0.05)'
      };
    }
  `}
`;

export const ClearButton = styled.button`
  margin-top: 12px;
  padding: 8px 16px;
  background: transparent;
  border: 1px solid
    ${({ theme }) =>
      theme?.name === 'dark' ? 'rgba(255,255,255,0.2)' : '#e2e8f0'};
  border-radius: 6px;
  color: ${({ theme }) => (theme?.name === 'dark' ? '#9CA3AF' : '#64748b')};
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) =>
      theme?.name === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)'};
  }
`;

export const FooterActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding: 16px 24px;
  border-top: 1px solid
    ${({ theme }) => (theme?.name === 'dark' ? '#374151' : '#e2e8f0')};
  background: ${({ theme }) =>
    theme?.name === 'dark' ? '#111827' : '#f9fafb'};
`;
